export default {
  mounted(el: HTMLElement, binding: any) {
    if (typeof binding.value === 'function') {
      binding.value(el)
    }
  },
}
